/* eslint-disable */
import { Button, Col, DatePicker, Form, Row, Select } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataRead as GetCompany } from "../../redux/companies/actionCreator";
import { DataRead as GetUsers } from "../../redux/users/actionCreator";
import { DataRead as GetEngineers } from "../../redux/engineers/actionCreator";
import { DataRead as GetJobDescription } from "../../redux/jobDescription/actionCreator";
import { getFilterData as GetFilterData } from "../../redux/jobs/actionCreator";
import moment from 'moment';

function Filters({ onApply = () => false, filters = {}, hideJobDescription = false, hideTargetPort = false }) {
    const dispatch = useDispatch();
    const jobDescription = useSelector(store => store.jobDescription);
    const engineers = useSelector(store => store.engineer);
    const company = useSelector(store => store.company);
    const { data:users, loading:userLoading } = useSelector(store => store.users);
    const [form] = Form.useForm();
    const {
        getFilterLoading,
        getFilterData,
    } = useSelector(store => store.jobs);

    const getInitialState = () => {
        if (Object.keys(filters).length) {
            form.resetFields();
        }
        return filters;
    };

    const handleSubmit = (values) => {
        onApply(values);
    }

    useEffect(() => {
        dispatch(GetCompany())
        dispatch(GetEngineers())
        dispatch(GetJobDescription())
        dispatch(GetFilterData())
        dispatch(GetUsers(0))
    }, [dispatch])

    return (<Form
        className=" px-1"
        layout="vertical"
        initialValues={getInitialState()}
        form={form}
        onFinish={handleSubmit}
    >
        <Row gutter={15}>
            <Col span={24}>
                <Form.Item label={"Companies"}
                    name="company" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select companies"
                        mode="multiple"
                        loading={company?.loading}
                        options={company?.data ?? []}
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label={"Engineers"} name="engineers">
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select engineers"
                        mode="multiple"
                        loading={engineers?.loading}
                        options={engineers?.data ?? []}
                    />
                </Form.Item>
            </Col>

            {!hideJobDescription && <Col span={24}>
                <Form.Item label={"Job Descriptions"} name="jobDescriptions" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select job descriptions"
                        mode="multiple"
                        loading={jobDescription?.loading}
                        options={jobDescription?.data ?? []}
                    />
                </Form.Item>
            </Col>}

            <Col span={24}>
                <Form.Item label={"Descriptions"} name="descriptions" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select descriptions"
                        mode="multiple"
                        loading={getFilterLoading}
                        options={getFilterData?.description ?? []}
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label={"Ship Names"} name="shipNames" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select shipnames"
                        mode="multiple"
                        loading={getFilterLoading}
                        options={getFilterData?.shipName ?? []}
                    />
                </Form.Item>
            </Col>
            {!hideTargetPort && <Col span={24}>
                <Form.Item label={"Target Ports"} name="targetPorts" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select target ports"
                        mode="multiple"
                        loading={getFilterLoading}
                        options={getFilterData?.targetPort ?? []}
                    />
                </Form.Item>
            </Col>}
            <Col span={24}>
                <Form.Item label={"Vessel Class"} name="boxVesselClass" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select vessel class"
                        mode="multiple"
                        loading={getFilterLoading}
                        options={getFilterData?.boxVesselClass ?? []}
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label={"Job Created By"} name="createdBy" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select users"
                        mode="multiple"
                        loading={userLoading}
                        options={users ?? []}
                    />
                </Form.Item>
            </Col>

            <Col span={24}>
                <Form.Item label={"Job Last Updated By"} name="updatedBy" >
                    <Select
                        showSearch
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        className="[&>div]:py-[10px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:rounded-6 [&>.ant-select-arrow]:text-theme-gray dark:[&>.ant-select-arrow]:text-white60 [&>div>div>div>span]:bg-transparent [&>div>div>div>span]:h-[26px] [&>div>div>div>span]:items-center"
                        placeholder="Please select users"
                        mode="multiple"
                        loading={userLoading}
                        options={users ?? []}
                    />
                </Form.Item>
            </Col>


            <Col span={24}>
                <Form.Item label="Vessel ETA" name="vesselETA">
                    <DatePicker disabledDate={(current) => current < moment().startOf('day')} className=" w-full h-12" />
                </Form.Item>
            </Col>

            <Col span={24}>
                <Form.Item>
                    <div className="flex items-center min-md:justify-end justify-center mt-[15px]">
                        <Button
                            className="bg-regularBG dark:bg-regularBGdark h-[38px] ltr:mr-[20px] rtl:ml-[20px] px-[22px] text-[15px] text-body dark:text-white60 hover:text-light font-normal border-regular dark:border-white10"
                            onClick={() => {
                                return form.resetFields();
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            htmlType="submit"
                            type="primary"
                            className="bg-primary hover:bg-primary-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-primary"
                        >
                            {"Apply"}
                        </Button>
                    </div>
                </Form.Item>
            </Col>
        </Row>
    </Form>);
}

export default Filters;
